import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {LanguageService} from '../language/language.service';
import {ILanguage} from '../language/language.model';

@Component({
    selector: 'app-language-select',
    templateUrl: './language-select.component.html',
    styleUrls: ['./language-select.component.scss'],
    standalone: false
})
export class LanguageSelectComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() controlName = 'language';

  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();


  languages: ILanguage[];

  constructor(
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.languageService.getLanguages().subscribe(result => this.languages = result);
  }

  onSelectionChanged(event) {
    this.selectionChange.emit(event);
  }

}
